import React, { ReactElement } from 'react';

const Welcome = (): ReactElement => {
  return (
    <div>
      <h1>Welcome</h1>
    </div>
  );
};

export default Welcome;
